import { ProfileRoles } from '@src/utils/enums';

export const rolesHelperContent = (
  <>
    Role Descriptions:
    <ol>
      <li>
        <p>
          <span className='text-bold'>Applicant</span> – Entity with desire to undertake the proposed activity that
          possesses or will possess the requisite property interest.
        </p>
      </li>
      <li>
        <p>
          <span className='text-bold'>Agent</span> - Entity acting on behalf of the applicant.
        </p>
      </li>
      <li>
        <p>
          <span className='text-bold'>External Agency</span> – Future Capability
        </p>
      </li>
      <li>
        <p>
          <span className='text-bold'>USACE Regulatory User</span> – Internal USACE Project Managers and RRS
          Administrators.
        </p>
      </li>
    </ol>
  </>
);

export const organizationTypes = {
  headquarters: 'headquarters',
  division: 'division',
  district: 'district',
};

export const cleanProfileData = (contact) => {
  const updatedContact = { ...contact };

  if (!contact?.phoneOne || contact?.phoneOne?.trim() === '') {
    updatedContact.phoneOneCountryCode = null;
  }

  if (!contact?.phoneTwo || contact?.phoneTwo?.trim() === '') {
    updatedContact.phoneTwoCountryCode = null;
  }

  if (!contact?.faxPhone || contact?.faxPhone?.trim() === '') {
    updatedContact.faxCountryCode = null;
  }

  if (contact?.role === ProfileRoles.USACERegulator) {
    updatedContact.country = null;
  }

  return updatedContact;
};

export const getAgencyType = (agencyType) => {
  if (!agencyType) {
    return [];
  }
  return agencyType.map((val) => ({ value: val, label: val }));
};

export const getOrganizationValue = (organization) => {
  if (typeof organization === 'number' || typeof organization === 'string') {
    return Number(organization);
  }
  const value = organization?.value ?? organization?.orgID;
  return value !== undefined && value !== null ? Number(value) : null;
};

export const getUsaceOrganizationValue = getOrganizationValue;

export const getOrganizationParentId = (organization) => {
  const parentOrgId = organization?.parentOrgId ?? organization?.parentOrgID;
  return parentOrgId !== undefined && parentOrgId !== null ? Number(parentOrgId) : null;
};

export const getOrganizationLabel = (organization) => {
  if (organization?.label) {
    return organization.label;
  }
  return organization?.shortName ? `${organization.orgName} (${organization.shortName})` : organization?.orgName;
};

export const mapOrganizationToOption = (organization, type) => {
  if (!organization) {
    return null;
  }

  const orgId = getOrganizationValue(organization);
  const parentOrgId = getOrganizationParentId(organization);

  return {
    ...organization,
    value: orgId,
    label: getOrganizationLabel(organization),
    orgId,
    orgID: orgId,
    orgName: organization?.orgName,
    parentOrgId,
    parentOrgID: parentOrgId,
    shortName: organization?.shortName,
    type,
  };
};

const getSelectedOrganizationOptions = (organizations, organizationOptions = []) => {
  if (!organizations?.length || !organizationOptions?.length) {
    return [];
  }

  const selectedOrganizationIds = new Set(
    organizations.map(getOrganizationValue).filter((value) => value !== null && !Number.isNaN(value))
  );
  return organizationOptions.filter((option) => selectedOrganizationIds.has(getOrganizationValue(option)));
};

export const getOrganizations = (organizations, organizationOptions = []) =>
  getSelectedOrganizationOptions(organizations, organizationOptions);

export const shouldSaveOrganizationsForRole = (role) =>
  role === ProfileRoles.USACERegulator || role === ProfileRoles.ExternalAgency;

export const getOrganizationIds = (organizations = []) => organizations.map(getUsaceOrganizationValue).filter(Boolean);
